import React from 'react';
import MoneyInput from 'components/MoneyInput';
import { useRateCalculations } from '../hooks/useRateCalculations';

type Props = {
  source: string;
  inheritedSettings: any;
};

export const BlendedRateCentsInput = ({ source, inheritedSettings }: Props) => {
  const { handlers } = useRateCalculations({ source, inheritedSettings });

  return (
    <MoneyInput
      source={`${source}.blended_rate_cents`}
      label="12hr Charge Rate"
      onChange={(event) => handlers.handleBlendedRateChange(event.target.value)}
    />
  );
};
